import { OperatorDropdown } from "src/base-components/OperatorDropdown";
import { CustomDropdownFilter } from "src/base-components/tableColumnFilters/CustomDropdownFilter";
import { SimpleOperatorInput } from "src/base-components/tableColumnFilters/SimpleOperatorInput";
import { useFilter } from "src/base-components/tableColumnFilters/useFilters";
import { getOperatorDefinition, Operator } from "src/constants/operators";

const STRING_OPERATORS: Operator[] = [
  "str_contains",
  "eq",
  "starts_with",
  "ends_with",
  "like",
];

export const StringFilter: React.FC<{
  property: string;
  displayName: string;
  dataLoc?: string;
  operators?: Operator[];
}> = ({ property, displayName, operators = STRING_OPERATORS, dataLoc }) => {
  const { filters, update, apply, reset, isFiltering, isApplied } = useFilter(
    property,
    [
      {
        key: property,
        operator: operators[0] ?? "eq",
        values: [],
      },
    ],
  );

  const filter = filters[0];
  const value = filter.values[0];

  return (
    <CustomDropdownFilter
      dataLoc={dataLoc}
      description={`Filter by ${displayName}`}
      isApplied={isApplied()}
      isFiltering={isFiltering({ key: property })}
      operator={filter.operator}
      value={value}
      onApply={apply}
      onResetRequest={() => {
        reset();
      }}
    >
      <SimpleOperatorInput
        prefix={
          <OperatorDropdown
            options={operators.map((operator) => ({
              key: operator,
              value: getOperatorDefinition(operator),
            }))}
            value={filter.operator as Operator}
            onChange={(value) => {
              update([{ ...filter, operator: value }]);
            }}
          />
        }
        value={value ?? ""}
        onChange={(value) => update([{ ...filter, values: [value] }])}
      />
    </CustomDropdownFilter>
  );
};
